import Entity from "entity";
import Rodada from 'entity/Rodada'
import { ValidatorHelper } from "functions";
import { clearAtributes } from "util/object";
import { getReuniaoEntre, getReuniaoNoHorario } from "./funtions";
import { fetchArray } from "entity";

export default class Reuniao extends Entity {
    static get collectionUID() {
        return "Reuniao";
    }
    async initialize() {
        this.data.status = "ATIVO";
    }
    static async onQuery(collection) {
        return collection//.where("status", "==", "ATIVO").orderBy("nome");
    }

    async preSave(entity) {

        clearAtributes(entity.data, "rodada", ["uid", "nome", "possiveisReunioes"])
        clearAtributes(entity.data, "inscricao1", ["uid", "nome", "tipo", 'status', 'statusEvento', 'empresa', 'termo'])
        clearAtributes(entity.data, "inscricao2", ["uid", "nome", "tipo", 'status', 'statusEvento', 'empresa', 'termo'])
        entity.data.inscricoesQuery = {}
        entity.data.inscricoesQuery[entity.data.inscricao1.uid] = true
        entity.data.inscricoesQuery[entity.data.inscricao2.uid] = true

    }

    static async validFieldErrors(values) {
        console.log('values', values)
        let v = new ValidatorHelper();

        let errorsMessage = v.valid(values);

        if (errorsMessage.length) {
            return errorsMessage
        }

        let reunioes = await getReuniaoEntre(values.inscricao1.uid, values.inscricao2.uid)
        reunioes = reunioes.filter(r => r.uid !== values.uid)
        if (reunioes.length) {
            return ["Já exite reunião marcada entre estas empresas: " + reunioes[0].horariotxt + " - " + reunioes[0].mesa.name]
        }

        let reunioesHora = await getReuniaoNoHorario(values.inscricao1.uid, values.inscricao2.uid, values.horario.horario)
        reunioesHora = reunioesHora.filter(r => r.uid !== values.uid)
        if (reunioesHora.length) {
            return ["Participante já possui reunião para este horario: " + reunioesHora[0].horariotxt + " - " + reunioesHora[0].mesa.name]
        }

        // validation for table and time conflict
        if (values.mesa && values.horario && values.rodada) {
            try {
                let query = await Reuniao.query();
                query = query.where("rodada.uid", "==", values.rodada.uid)
                query = query.where("status", "==", "ATIVO")
                query = query.where("mesa.uid", "==", values.mesa.uid)
                query = query.where("horario.horario", "==", values.horario.horario)

                const result = await fetchArray(query.get());
                const reunioesConflito = result.filter(r => r.uid !== values.uid);

                if (reunioesConflito.length > 0) {
                    return [`A mesa "${values.mesa.name}" já está ocupada. Escolha outra mesa.`]
                }
            } catch (error) {
                console.error('Erro ao trocar mesa: ', error);
            }
        }

        return null
    }

    // tentando enviar um array ao inves de uma entidade p/ os valores serem
    // atualizados através do array ao invés de uma entidade
    // { field: "mesa", arr: await getAllMesas() }
    static get updatedValues() {
        return [
            {
                field: "rodada",
                entityValue: Rodada,
                // specific: {
                //     field: "mesa",
                //     entityField: "mesas"
                // }

                // specificField: "mesa",
                // arrSpecificPath: "mesas"
            },
        ]
    }

    static get searchColumns() {
        return [
            { field: "status", headerName: "STATUS", flex: 0.3, filter: true },
            { field: "rodada.nome", headerName: "RODADA", flex: 1, filter: true },
            { field: "mesa.name", headerName: "MESA", flex: 0.5, filter: true },
            { field: "horariotxt", headerName: "HORÁRIO", flex: 0.5 },
            { field: "inscricao1.empresa.nomeFantasia", headerName: "PARTICIPANTE 1", flex: 1, filter: true },
            { field: "inscricao2.empresa.nomeFantasia", headerName: "PARTICIPANTE 2", flex: 1, filter: true },
            { field: "obs", headerName: "OBS", flex: 1, filter: true },
        ];
    }
}